// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"cde45c74","70":"e17b38d0","88":"4ee71748","152":"4fd32357","163":"de8bf72a","235":"347a92b8","331":"4de3257c","375":"4c7eba47","392":"de679758","724":"bc279b2f","725":"7d3cdc21","731":"c0f37575","790":"6ed51825","986":"bfc9b038"}[chunkId] + ".chunk.js";
};